export const hubToSortationMap: Record<string, string> = {
  HUB_ORD: "SC_ORD_1",
  HUB_ATL: "SC_ATL_1",
  HUB_DFW: "SC_DFW_1",
  HUB_FON: "SC_LAX_1",
  LAX1CD: "SC_LAX_1",
  EWR1CD: "SC_EWR_1",
};
